import { Reveal, ChapterTag } from "./motion";
import { Check, X, PawPrint } from "lucide-react";

const PELOCERO = ["Reusable", "No refills", "No electricity needed", "Compartment that collects the hair"];
const RODILLO = ["Constant refill purchases", "Creates waste", "Runs out", "Loses stickiness"];

export const Comparison = () => (
  <section id="comparativa" data-testid="comparison-section" className="py-16 sm:py-24 lg:py-32 bg-zinc-50">
    <div className="max-w-4xl mx-auto px-4 sm:px-6">
      <Reveal>
        <ChapterTag num="05" label="Comparison" />
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-balance">
          PeloCero vs. sticky lint roller
        </h2>
      </Reveal>
      <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-6">
        <Reveal>
          <div data-testid="comparison-pelocero" className="h-full rounded-3xl bg-ink text-white p-7 sm:p-9 relative overflow-hidden">
            <PawPrint className="absolute -right-6 -bottom-6 w-32 h-32 text-white/5" />
            <p className="font-display font-bold text-xl flex items-center gap-2">
              <span className="w-7 h-7 rounded-full bg-brand flex items-center justify-center">
                <PawPrint className="w-3.5 h-3.5 text-white" />
              </span>
              PeloCero
            </p>
            <ul className="mt-6 space-y-4">
              {PELOCERO.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm sm:text-base">
                  <Check className="w-5 h-5 text-green-400 shrink-0 mt-0.5" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
        <Reveal delay={0.12}>
          <div data-testid="comparison-rodillo" className="h-full rounded-3xl bg-white border border-zinc-200 p-7 sm:p-9">
            <p className="font-display font-bold text-xl text-zinc-400">Sticky lint roller</p>
            <ul className="mt-6 space-y-4 text-zinc-500">
              {RODILLO.map((item) => (
                <li key={item} className="flex items-start gap-3 text-sm sm:text-base">
                  <X className="w-5 h-5 text-red-400 shrink-0 mt-0.5" />
                  {item}
                </li>
              ))}
            </ul>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
